import { call, put, select } from 'redux-saga/effects'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import { updateGasMeterModuleConfiguration } from '../../../SubscriptionFormConfigurationSlice'
import * as Sentry from '@sentry/react'

export const pceModuleActions = {
  METER_MODULE_CHECK_DUPLICATED: 'METER_MODULE_CHECK_DUPLICATED',
  METER_MODULE_REQUEST_DATA: 'METER_MODULE_REQUEST_DATA',
  METER_MODULE_VALIDATE_METER_SYNTAX: 'METER_MODULE_VALIDATE_METER_SYNTAX',
  METER_MODULE_LOAD_ENERGY_SUPPLIERS_GAS: 'METER_GAS_LOAD_ENERGY_SUPPLIERS_GAS',
}

export function* checkDuplicatedMeter({ meterId, energyType, duplicatedCallback }) {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { pod_validate_duplicated_url: url } = yield select(selectPageConfigurationData)
  const fullUrl = `${url}?lang=${lang}&meterId=${meterId}&energyType=${energyType}`
  try {
    const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
    const response = yield call(fetch, fullUrl, config)
    const result = yield call([response, response.json])
    if (response.status === 200) {
      yield call(duplicatedCallback, result)
    } else {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('checkDuplicatedMeterError'), { extra: { result, status: response.status } })
      }
      yield call(duplicatedCallback, null)
    }
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'checkDuplicatedMeterError' } })
    }
  }
}

export function* requestMeterData({ body }) {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { pod_eligibility_url: url } = yield select(selectPageConfigurationData)
  try {
    yield put(
      updateGasMeterModuleConfiguration({
        pceEligibilityLoading: true,
        pceEligibilityData: {},
      }),
    )
    const config = yield call(getAPIConfig, { method: 'post', authTokenSession, body })
    const response = yield call(fetch, url + '?lang=' + lang, config)
    yield call([response, response.json])
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'requestMeterDataError' } })
    }
  }
}

export function* validateMeterSyntax({ meterId, callback }) {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { pod_validate_url: url } = yield select(selectPageConfigurationData)
  const fullUrl = `${url}?lang=${lang}&meterId=${meterId}`
  try {
    const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
    const response = yield call(fetch, fullUrl, config)
    const result = yield call([response, response.json])
    if (response.status === 200) {
      yield call(callback, result)
    } else {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('validateMeterSyntaxError'), { extra: { result, status: response.status } })
      }
    }
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'validateMeterSyntaxError' } })
    }
  }
}

export function* loadGasEnergySuppliers() {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { load_supplier_options_url: url } = yield select(selectPageConfigurationData)
  const fullUrl = `${url}?lang=${lang}&energy=gas`

  try {
    const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
    const response = yield call(fetch, fullUrl, config)
    const isValid = response.status === 200
    const responseData = yield call([response, response.json])
    if (!isValid) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('loadGasEnergySuppliersError'), { extra: { responseData, status: response.status } })
      }
      return
    }
    yield put(updateGasMeterModuleConfiguration({ energySuppliers: responseData }))
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'loadGasEnergySuppliersError' } })
    }
  }
}
